import ValueX from '../types/ValueX';

export default class AnswerX extends ValueX {
    static __className = 'AnswerX';

    constructor(constructJson) {
        super(constructJson, 'answer', 'AnswerX');
    }
}
